export default __webpack_public_path__ + "assets/images/2fee59cc50e3cec5cf53bf0b9fbabda6.svg";